import React from 'react'

const CodeEditorIcon = props => {
  const height = props.height || 32
  const width = props.width || 32
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" strokeWidth={strokeWidth}>
      <g stroke={color} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.31 20.34 26 14.65l-5.69-5.689M18.064 6l-6.18 17.946M9.69 8.961 4 14.651l5.69 5.69" stroke={color}></path>
      </g>
    </svg>
  )
}

export default CodeEditorIcon
